if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.requestNumber = 0;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-pickup-store]');
        if (!button || !this.contains(button)) return;
        const panel = document.getElementById('Pickup-Availability');
        if (!panel) return;
        event.preventDefault();
        panel.querySelectorAll('[data-pickup-location]').forEach((item) => {
          item.hidden = item.dataset.pickupLocation !== button.dataset.pickupStore;
        });
        panel.classList.add('active');
        document.body.classList.add('open-cc');
      });
      this.availabilityObserver = new MutationObserver(() => {
        if (!this.hasAttribute('available')) {
          this.requestNumber += 1;
          if (this.controller) this.controller.abort();
          this.clearPreview();
        }
      });
      this.availabilityObserver.observe(this, { attributes: true, attributeFilter: ['available'] });
      if (this.hasAttribute('available')) this.fetchAvailability(this.dataset.variantId);
    }

    clearPreview() {
      this.innerHTML = '';
      this.style.display = 'none';
      const panel = document.getElementById('Pickup-Availability');
      if (panel) {
        if (panel.classList.contains('active')) document.body.classList.remove('open-cc');
        panel.classList.remove('active');
        panel.innerHTML = '';
      }
    }

    fetchAvailability(variantId) {
      const requestNumber = ++this.requestNumber;
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.dataset.variantId = variantId || '';
      this.clearPreview();
      if (!variantId) {
        this.removeAttribute('available');
        return;
      }
      const rootUrl = (this.dataset.rootUrl || '/').replace(/\/?$/, '/');
      fetch(`${rootUrl}variants/${encodeURIComponent(variantId)}/?section_id=pickup-availability`, {
        signal: this.controller.signal
      })
        .then((response) => {
          if (!response.ok) throw new Error('Pickup availability could not be loaded');
          return response.text();
        })
        .then((text) => {
          if (requestNumber !== this.requestNumber) return;
          const section = new DOMParser().parseFromString(text, 'text/html');
          this.renderPreview(section);
        })
        .catch((error) => {
          if (error.name !== 'AbortError' && requestNumber === this.requestNumber) this.renderError();
        });
    }

    onClickRefreshList() {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.clearPreview();
      this.removeAttribute('available');
    }

    renderPreview(section) {
      const preview = section.querySelector('[data-pickup-preview]');
      if (!preview || !preview.querySelector('[data-pickup-store]')) {
        this.renderError();
        return;
      }
      this.innerHTML = preview.innerHTML;
      const sourcePanel = section.querySelector('.side-availability');
      const panel = document.getElementById('Pickup-Availability');
      if (panel && sourcePanel) panel.innerHTML = sourcePanel.innerHTML;
      this.setAttribute('available', '');
      this.style.display = 'block';
    }
  });
}
